import React, { useState, useEffect } from "react";
import Topbar from "../Topbar";
import Footer from "../Footer";
import { Banner, Btn, ContainerLayout, BtnDiv, Text } from "./LayoutStyle";
import { Container, Row } from 'reactstrap';

const cookieStorage = {
  getItem: (key) => {
    const cookies = document.cookie
      .split(";")
      .map((cookie) => cookie.split("="))
      .reduce((acc, [key, value]) => ({ ...acc, [key.trim()]: value }), {});
    return cookies[key];
  },
  setItem: (key, value) => {
    document.cookie = `${key}=${value}`;
  },
};

const storageType = cookieStorage;
const consentPropertyName = "cookie_consent";
//returns a true value when the cookie consents exist
//checks if the cookie exists
const shouldShowPopup = () => storageType.getItem(consentPropertyName);

//stores the cookie to the local storage when accepted
const saveToStorage = () => storageType.setItem(consentPropertyName, true);

export const Layout = (props) => {
  const [hide, setHide] = useState(false);

  //TO-DO FIX WARNING ARRAY PARAMETERS
  useEffect(() => {
    //document.title = `the hide state is ${hide}`;
    //checks if the cookie exists
    if (shouldShowPopup(storageType)) {
      setHide(true);
    }
  }, []);

  const handleClick = () => {
    saveToStorage(storageType);
    //sets the state to true
    setHide(true);
  };

  return (
    <ContainerLayout>
      <Topbar />
      {props.children}
      <Footer />
      <Banner display={hide}>
        <Container>
          <Row>
            <Text md="10" xs="12">This site does not collect any information from users.</Text>
            <BtnDiv md="2" xs="12"><Btn onClick={() => handleClick()}>Accept</Btn></BtnDiv>
          </Row>
        </Container>
      </Banner>
    </ContainerLayout>
  );
};

export default Layout;
